import { useMemo } from "react";
import renderMathInElement from "katex/contrib/auto-render";
import "katex/dist/katex.min.css";
import { sanitizeHtml } from "@/lib/sanitize";

const DELIMITERS = [
  { left: "$$", right: "$$", display: true },
  { left: "$", right: "$", display: false },
  { left: "\\(", right: "\\)", display: false },
  { left: "\\[", right: "\\]", display: true },
];

// Renders sanitized admin HTML with LaTeX ($...$ / $$...$$) pre-typeset by KaTeX.
// Math is rendered synchronously into a detached node, the result is sanitized
// (DOMPurify) and injected in a single pass, so parent re-renders never wipe it.
export default function RichContent({ html, className = "" }) {
  const rendered = useMemo(() => {
    if (!html) return "";
    if (typeof document === "undefined") return sanitizeHtml(html);
    const el = document.createElement("div");
    el.innerHTML = sanitizeHtml(html);
    try {
      renderMathInElement(el, { delimiters: DELIMITERS, throwOnError: false });
    } catch {
      // KaTeX failed on malformed input; raw (sanitized) text is kept.
    }
    return el.innerHTML;
  }, [html]);

  return (
    <div
      className={`rich-content ${className}`}
      dangerouslySetInnerHTML={{ __html: rendered }}
    />
  );
}
